
const LOCAL = /localhost/

const getRoute = (path, host) => {

	const segments = path.split("/").filter(Boolean)
	if (LOCAL.test(host)) {
		return segments[0] 
	}
	return segments.length > 0 ? segments[segments.length - 1] : undefined
}


export { getRoute }